<template>
    <a-form :form="form">
        <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Tax Type">
                  <a-select v-decorator="['tax_type', { rules: [{ required: true }], initialValue: null }]">
                      <a-select-option v-for="item in getType_tax" :key="item.value" :value="item.value">
                          {{ item.text }}
                      </a-select-option>
                  </a-select>
              </a-form-item>
              <a-form-item label="Month-Year">
                  <a-month-picker placeholder="Select Month-Year" :format="'MM-YYYY'" picker="month" :allowClear="true"
                      v-decorator="['month_year', { rules: [{ required: true }], initialValue: null }]" />
              </a-form-item>
              <a-form-item label="Value">
                <a-input-number class="m-width-full m-text-align-right" v-decorator="[
                  'value',
                  {
                    rules: [{ required: true }],
                    initialValue: null,
                  },
                ]" @keydown="onlyNumber" :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\\s?|(,*)/g, '')"></a-input-number>
              </a-form-item>
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['note']"
                />
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="KAP">
                    <a-input v-decorator="['kap', {
                        rules: [{ required: true }],
                        initialValue: null,
                    }]"></a-input>
                </a-form-item>
                <a-form-item label="KJS">
                    <a-input v-decorator="['kjs', {
                        rules: [{ required: true }],
                        initialValue: null,
                    }]"></a-input>
                </a-form-item>
                <a-form-item label="File Document Tax">
                <a-upload
                    :fileList="fileList"
                    v-decorator="[
                      'file_document_tax',
                      { rules: [{ required: true, validator: doc_validation }] },
                    ]"
                    :remove="handleRemove"
                    :beforeUpload="beforeUpload"
                >
                    <a-button>
                    <a-icon type="upload" />Select File
                    </a-button>
                </a-upload>
              </a-form-item>
            </a-col>
        </a-row>
    </a-form>
</template>
<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";

export default {
  name: "plan_PBK",
  mixins: [GlobalMethod],
  data() {
      let doc_validation = (rule, value, callback) => {
      if (this.fileList && (this.fileList == null || this.fileList.length==0)) {
        callback(new Error("File Document Tax is required"));
      } else {
        callback();
      }
    };
      return {
        fileList: [],
        doc_validation
      }
    },
    created() {
        this.form = this.$form.createForm(this);
    },
    mounted() {
        this.$store.dispatch("Fetch_TYPE_TAX");
    },
    computed: {
        ...mapGetters([
            "getScreen",
            "getAuth",
            "getStandartFormatDate",
            "getDateTimeFormat",
            "getDefaultDateFormat",
            "getType_tax",
        ]),
  },
  methods: {
    moment,
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);
        return false;
      }
    },
    handleRemove() { 
      
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        Event.$emit("dataPBK", {
          values: {
            file_document_tax: values.file_document_tax ? values.file_document_tax.file : null,
            kap : values.kap,
            kjs : values.kjs,
            month_year : moment(values.month_year).format('YYYY-MM'),
            tax_type : values.tax_type,
            value: values.value,
            note: values.note
          }
        });
      })
    }
  }
}
</script>